import { achievements } from '../../data/achievements';
import { useAchievementScroll } from '../../hooks/useAchievementScroll';
import AchievementItem from './AchievementItem';

interface AchievementListProps {
  count: number;
}

const AchievementList = ({ count }: AchievementListProps) => {
  const { listRef, thumbRef, scrollPos, updateScroll } =
    useAchievementScroll(count);
  const nextIndex = achievements.findIndex(a => count < a.count);

  return (
    <section
      className={`content__achievements-wrapper content__achievements-wrapper--${scrollPos}`}
      aria-label="Рубежи"
    >
      <ul
        ref={listRef}
        className="content__achievements"
        onScroll={updateScroll}
      >
        {achievements.map((achievement, index) => (
          <AchievementItem
            key={achievement.id}
            achievement={achievement}
            index={index}
            count={count}
            nextIndex={nextIndex}
            listRef={listRef}
          />
        ))}
      </ul>
      <div className="content__scrollbar-track" role="presentation">
        <div ref={thumbRef} className="content__scrollbar-thumb" />
      </div>
    </section>
  );
};

export default AchievementList;
